
/* —————————————————— CARD PRODUCT —————————————————— */

function cardSelectSwitchColor(cardId, id, url){
  //console.log(id, url);
  var card = $("#" + cardId);

  card.find(".card-media").hide();
  card.find("#media-" + id).show();
  
  card.find(".main").hide();
  card.find("#main-" + id).show();

  card.find(".dh-switch").removeClass("active");
  card.find("#switch-" + id).addClass("active");

  card.find(".options").hide();
  card.find("#options-" + id).show();
}

function cardProductBuyButton(id){
  console.log(id);
  
  var button = $("#ProductSubmitButton-" + id);
  button.click();
}


/* —————————————————— FAQ —————————————————— */

function openFaq(element){
  var el = $(element);

  el.toggleClass("active");
  el.find(".answer").slideToggle();
  
}


/* —————————————————— VIDEO —————————————————— */
function startVideoWithControls(el, id, element, size, type) {
  var ref = id + "-" + element + "-" + size + "-" + type;
  var controls = $("#controls-" + ref);

  controls.fadeOut();
  
  const video = document.querySelector(".video-" + ref);
  video.muted = false;
  video.controls = true;
  video.currentTime = 0;

  // Per garantire la riproduzione con audio su interazione utente
  video.play().catch(err => {
    console.warn("Playback failed:", err);
  });
}


function isElementVisible(el) {
  if (!el || !(el instanceof Element)) return false;

  let current = el;
  // 1. Salgo la catena di parent e verifico i CSS ereditati
  while (current) {
    const style = window.getComputedStyle(current);

    if (style.display === 'none')      return false;
    if (style.visibility === 'hidden') return false;
    if (parseFloat(style.opacity) === 0) return false;

    current = current.parentElement;
  }

  return true;
}



function playVIMEOVideo(el, id, type, size, type, vimeo){
  var element = $(el).attr("data-element");
  var size = $(el).attr("data-size");
  var type = $(el).attr("data-type");

  var id_iframe = "vimeo-"+id+"-"+vimeo+"-"+size+"-"+type;

  console.log(id_iframe);

  const iframe = document.getElementById(id_iframe);
  console.log(iframe);
  
  const url = new URL(iframe.src);

  url.searchParams.set('background', 0);
  url.searchParams.set('muted', 0);
  url.searchParams.set('controls', 1);
  url.searchParams.set('playsinline', 0);
  iframe.src = url.toString();

  let player = new Vimeo.Player(iframe);
  console.log(player);
  player.play();
  
  $("#controls-"+id+"-"+element+"-"+size+"-"+type).fadeOut(); 
}

function initVimeoBGVideo() {
  // Select all elements that have [data-vimeo-bg-init]
  const vimeoPlayers = document.querySelectorAll('[data-vimeo-bg-init]');

  //console.log("VIMEO", vimeoPlayers);
  
  vimeoPlayers.forEach(function(vimeoElement, index) {
    
    // Add Vimeo URL ID to the iframe [src]
    // Looks like: https://player.vimeo.com/video/1019191082
    const vimeoVideoID = vimeoElement.getAttribute('data-vimeo-video-id');
    if (!vimeoVideoID) return;
    const vimeoVideoURL = `https://player.vimeo.com/video/${vimeoVideoID}?api=1&background=1&autoplay=0&loop=1&muted=1`;
    vimeoElement.querySelector('iframe').setAttribute('src', vimeoVideoURL);

    // Assign an ID to each element
    const videoIndexID = 'vimeo-bg-index-' + index;
    vimeoElement.setAttribute('id', videoIndexID);

    const iframeID = vimeoElement.id;
    const player = new Vimeo.Player(iframeID);

    let videoAspectRatio;
    
    // Update Aspect Ratio if [data-vimeo-update-size="true"]
    if (vimeoElement.getAttribute('data-vimeo-update-size') === 'true') {
      player.getVideoWidth().then(function(width) {
        player.getVideoHeight().then(function(height) {
          videoAspectRatio = height / width;
          const beforeEl = vimeoElement.querySelector('.vimeo-bg__before');
          if (beforeEl) {
            beforeEl.style.paddingTop = videoAspectRatio * 100 + '%';
          }
        });
      });
    }

    // Function to adjust video sizing
    function adjustVideoSizing() {
      const containerAspectRatio = (vimeoElement.offsetHeight / vimeoElement.offsetWidth) * 100;

      const iframeWrapper = vimeoElement.querySelector('.vimeo-bg__iframe-wrapper');
      if (iframeWrapper && videoAspectRatio) {
        if (containerAspectRatio > videoAspectRatio * 100) {
          iframeWrapper.style.width = `${(containerAspectRatio / (videoAspectRatio * 100)) * 100}%`;
        } else {
          iframeWrapper.style.width = '';
        }
      }
    }
    
    // Adjust video sizing initially
    if (vimeoElement.getAttribute('data-vimeo-update-size') === 'true') {
      adjustVideoSizing();
      player.getVideoWidth().then(function() {
        player.getVideoHeight().then(function() {
          adjustVideoSizing();
        });
      });
    } else {
      adjustVideoSizing();
    }

    // Adjust video sizing on resize
    window.addEventListener('resize', adjustVideoSizing);

    // Loaded
    player.on('play', function() {
      vimeoElement.setAttribute('data-vimeo-loaded', 'true');
    });

    // Autoplay
    if (vimeoElement.getAttribute('data-vimeo-autoplay') === 'false') {
      // Autoplay = false
      player.pause();
    } else {
      // Autoplay = true
      // If paused-by-user === false, do scroll-based autoplay
      if (vimeoElement.getAttribute('data-vimeo-paused-by-user') === 'false') {
        function checkVisibility() {
          const rect = vimeoElement.getBoundingClientRect();
          const inView = rect.top < window.innerHeight && rect.bottom > 0;
          inView ? vimeoPlayerPlay() : vimeoPlayerPause();
        }

        // Initial check
        checkVisibility();

        // Handle scroll
        window.addEventListener('scroll', checkVisibility);
      }
    }

    // Function: Play Video
    function vimeoPlayerPlay() {
      vimeoElement.setAttribute('data-vimeo-activated', 'true');
      vimeoElement.setAttribute('data-vimeo-playing', 'true');
      player.play();
    }

    // Function: Pause Video
    function vimeoPlayerPause() {
      player.pause();
    }
    
    // Paused
    player.on('pause', function() {
      vimeoElement.setAttribute('data-vimeo-playing', 'false');
    });

    // Click: Play
    const playBtn = vimeoElement.querySelector('[data-vimeo-control="play"]');
    if (playBtn) {
      playBtn.addEventListener('click', function() {
        vimeoPlayerPlay();
      });
    }

    // Click: Pause
    const pauseBtn = vimeoElement.querySelector('[data-vimeo-control="pause"]');
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function() {
        vimeoPlayerPause();
        // If paused by user => kill the scroll-based autoplay
        if (vimeoElement.getAttribute('data-vimeo-autoplay') === 'true') {
          vimeoElement.setAttribute('data-vimeo-paused-by-user', 'true');
          // Removing scroll listener (if you’d like)
          window.removeEventListener('scroll', checkVisibility);
        }
      });
    }
  });
}

